export default __webpack_public_path__ + "static/media/logoPasapMini.334df71f.svg";